import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "20", height: "15", x: "2", y: "4", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "8", height: "7", x: "6", y: "8", rx: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 8v7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 19v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 19v2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Microwave";
const Microwave = memo(themed(Icon));
export {
  Microwave
};
//# sourceMappingURL=microwave.js.map
